import { ApolloCache, Reference } from "@apollo/client"
import { ITEMTYPE_FRAGMENT } from "../fragment/itemType"

export const updateCacheItemType = ({
  cache,
  entryData,
  action,
}: {
  cache: ApolloCache<any>
  entryData: any
  action: "update" | "delete" | "add"
}) => {
  return cache.modify({
    fields: {
      itemTypes(existing = []) {
        const newItemTypeRef = cache.writeFragment({
          data: entryData,
          fragment: ITEMTYPE_FRAGMENT,
        })
        switch (action) {
          case "add":
            return [...existing, newItemTypeRef]
          case "delete":
            return [
              ...existing?.filter(
                (el: Reference | undefined) =>
                  el?.__ref !== newItemTypeRef?.__ref,
              ),
            ]
          case "update":
            const index = existing.findIndex(
              (el: Reference | undefined) =>
                el?.__ref !== newItemTypeRef?.__ref,
            )
            const items = [...existing]
            if (index > -1) {
              items[index] = newItemTypeRef
            }
            return items
        }
      },
      aggregateItemType(existing = {}) {
        let _all = existing?._count?._all
        switch (action) {
          case "add":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all + 1 : 0,
              },
            }
          case "delete":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all - 1 : 0,
              },
            }
        }
      },
    },
  })
}
